import './Home.scss'
import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { RIMenu } from './Menu/Menu';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Dashboard } from './dashboard/Dashboard';
import Billing from './billing/Billing';
import Subscription from './subscription/Subscription';
import TermsAndConditions from './termsandconditions/TermsAndConditions';
import UserProfile from './userprofile/UserProfile';
import AccountOwner from './userprofile/AccountOwner';
import SendEmailForm from './mail/EmailDashboard';
import MultiFactor from './userprofile/MultiFactor';
import Activities from './crm/Activities';
import Deals from './crm/Deals';
import CRM from './crm/CRM';
import UserManagement from './userManagement/UserManagement';
import Campaign from './mail/Campaign';
import Allmail from './mail/Allmail';
import Template from './mail/Template';
import MyTemplate from './mail/MyTemplates';
import CampaignPage from './mail/CampaignPage';


export const Home = () => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const navigate = useNavigate();
    const location = useLocation(); 

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const logOutUser = () => {
        navigate('/');
        handleMenuClose();
    };

    return (
        <Box className='overall-wrap'>
            <RIMenu />
            
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    marginTop: '9vh',
                    display: 'flex',
                    // alignItems: 'center',
                    textAlign: 'center',
                    justifyContent: 'center',
                    padding: '0px'
                }}
            >
                <Outlet />
                {location.pathname.includes('/dashboard') && <Dashboard />}
                {location.pathname.includes('/subscription') && <Subscription/> }
                {location.pathname.includes('/billingandpayment') && <Billing />}
                {location.pathname.includes('/billingandpayment/:id') && <Billing/>}
                {location.pathname.includes('/termsandconditions') && <TermsAndConditions/>}
                {location.pathname.includes('/userprofile') && <UserProfile />}
                {location.pathname.includes('/accountowner') && <AccountOwner />}
                {location.pathname.includes('/mail') && <SendEmailForm />}
                {location.pathname.includes('/multifactor') && <MultiFactor/>}
                 {location.pathname.includes('/crm') && <CRM/>}
                {location.pathname.includes('/deals') && <Deals />}
                {location.pathname.includes('/activities') && <Activities />}
                {location.pathname.includes('/user-management') && <UserManagement/>}
                {location.pathname.includes('/campaign') && <Campaign />}
                {location.pathname.includes('/allmail') && <Allmail />}
               {location.pathname.includes('/template') && <Template />}
                {location.pathname.includes('/mytemplate') && <MyTemplate />}
                {location.pathname.includes('/analysis') && <CampaignPage />}
            </Box>
        </Box>
    );
};